export const API_URL = 'https://rodeo-grill-api.vercel.app';
// export const API_URL = 'http://localhost:3001';